export const SHOW_IMPERSONATION_MODAL_EVENT = 'showImpersonationModal';
export const LANGUAGE_CHANGED_EVENT = 'languageChanged';
export const BOOKMARK_EVENT = 'bookmarkEvent';
export const APP_NOTIFICATION_STATE_EVENT = 'appNotificationStateChanged';
export const APP_NOTIFICATION_HIDDEN_EVENT = 'appNotificationHidden';
export const SHOW_APP_NOTIFICATION_BANNER_EVENT = 'showAppNotificationBanner';

export const HEADERS = 'STATIC.TOPBAR_HEADERS';
export const BOOKMARKS_PREFIX = 'STATIC.TOPBAR_BOOKMARKS';

export const BOOKMARK_GROUPS = {
    REPORT: 'report',
    PIVOT: 'pivot',
    RETENTION: 'retention',
    FRAUD: 'fraud',
    AD_MONETIZATION: 'adMonetization',
    CROSS_DEVICE: 'crossDevice',
    SKAN_RAW: 'skanRaw',
    SKAN_SUMMARY: 'skanSummary',
    UNIFIED_REPORT: 'unifiedReport',
    CREATIVE_EXPLORE: 'creativeExplore',
    CREATIVE_GALLERY: 'creativeGallery',
    ANOMALY_ANALYSIS: 'anomalyAnalysis',
};

export const BOOKMARK_GROUP_TRANSLATION_KEYS = {
    [BOOKMARK_GROUPS.REPORT]: `${BOOKMARKS_PREFIX}.TYPE_REPORT`,
    [BOOKMARK_GROUPS.PIVOT]: `${BOOKMARKS_PREFIX}.TYPE_PIVOT`,
    [BOOKMARK_GROUPS.RETENTION]: `${BOOKMARKS_PREFIX}.TYPE_RETENTION`,
    [BOOKMARK_GROUPS.FRAUD]: `${BOOKMARKS_PREFIX}.TYPE_FRAUD`,
    [BOOKMARK_GROUPS.AD_MONETIZATION]: `${BOOKMARKS_PREFIX}.TYPE_AD_MON`,
    [BOOKMARK_GROUPS.CROSS_DEVICE]: `${BOOKMARKS_PREFIX}.TYPE_CROSS_DEVICE`,
    [BOOKMARK_GROUPS.SKAN_RAW]: `${BOOKMARKS_PREFIX}.TYPE_SKAN_RAW`,
    [BOOKMARK_GROUPS.SKAN_SUMMARY]: `${BOOKMARKS_PREFIX}.TYPE_SKAN`,
    [BOOKMARK_GROUPS.UNIFIED_REPORT]: `${BOOKMARKS_PREFIX}.TYPE_UNIFIED`,
    [BOOKMARK_GROUPS.CREATIVE_EXPLORE]: `${BOOKMARKS_PREFIX}.TYPE_CREATIVE_EXPLORE`,
    [BOOKMARK_GROUPS.CREATIVE_GALLERY]: `${BOOKMARKS_PREFIX}.TYPE_CREATIVE_GALLERY`,
    [BOOKMARK_GROUPS.ANOMALY_ANALYSIS]: `${BOOKMARKS_PREFIX}.TYPE_ANOMALY_ANALYSIS`,
};

export const BOOKMARK_TYPE_TO_GROUP = {
    report: BOOKMARK_GROUPS.REPORT,
    pivot: BOOKMARK_GROUPS.PIVOT,
    retention: BOOKMARK_GROUPS.RETENTION,
    fraudProtected: BOOKMARK_GROUPS.FRAUD,
    fraudSuspicious: BOOKMARK_GROUPS.FRAUD,
    fraudRejected: BOOKMARK_GROUPS.FRAUD,
    adMonetization: BOOKMARK_GROUPS.AD_MONETIZATION,
    crossDevice: BOOKMARK_GROUPS.CROSS_DEVICE,
    skan: BOOKMARK_GROUPS.SKAN_RAW,
    skanSummary: BOOKMARK_GROUPS.SKAN_SUMMARY,
    unifiedReport: BOOKMARK_GROUPS.UNIFIED_REPORT,
    creativeExplore: BOOKMARK_GROUPS.CREATIVE_EXPLORE,
    creativeGallery: BOOKMARK_GROUPS.CREATIVE_GALLERY,
    anomalyAnalysis: BOOKMARK_GROUPS.ANOMALY_ANALYSIS,
};

export const BOOKMARK_GROUP_COLORS = {
    [BOOKMARK_GROUPS.REPORT]: { dot: '#2680eb', tint: '#e9f2fe' },
    [BOOKMARK_GROUPS.PIVOT]: { dot: '#7c5cff', tint: '#efeaff' },
    [BOOKMARK_GROUPS.RETENTION]: { dot: '#17a06e', tint: '#e2f6ee' },
    [BOOKMARK_GROUPS.FRAUD]: { dot: '#e5484d', tint: '#fdecec' },
    [BOOKMARK_GROUPS.AD_MONETIZATION]: { dot: '#f5843f', tint: '#fdeee1' },
    [BOOKMARK_GROUPS.CROSS_DEVICE]: { dot: '#d6459f', tint: '#fbe7f3' },
    [BOOKMARK_GROUPS.SKAN_RAW]: { dot: '#0b8bab', tint: '#e2f3f8' },
    [BOOKMARK_GROUPS.SKAN_SUMMARY]: { dot: '#6b8e23', tint: '#f0f5e3' },
    [BOOKMARK_GROUPS.UNIFIED_REPORT]: { dot: '#5b6ee1', tint: '#eaedfc' },
    [BOOKMARK_GROUPS.CREATIVE_EXPLORE]: { dot: '#9d44c4', tint: '#f5eafa' },
    [BOOKMARK_GROUPS.CREATIVE_GALLERY]: { dot: '#5f7d95', tint: '#eef3f7' },
    [BOOKMARK_GROUPS.ANOMALY_ANALYSIS]: { dot: '#14b8a6', tint: '#e2f6f4' },
};

export const BASE_BOOKMARK_GROUPS = [
    BOOKMARK_GROUPS.REPORT,
    BOOKMARK_GROUPS.PIVOT,
    BOOKMARK_GROUPS.AD_MONETIZATION,
    BOOKMARK_GROUPS.RETENTION,
    BOOKMARK_GROUPS.FRAUD,
    BOOKMARK_GROUPS.CROSS_DEVICE,
    BOOKMARK_GROUPS.SKAN_RAW,
    BOOKMARK_GROUPS.SKAN_SUMMARY,
    BOOKMARK_GROUPS.UNIFIED_REPORT,
    BOOKMARK_GROUPS.ANOMALY_ANALYSIS,
];

export const CREATIVE_IQ_BOOKMARK_GROUPS = [BOOKMARK_GROUPS.CREATIVE_EXPLORE, BOOKMARK_GROUPS.CREATIVE_GALLERY];

export const APP_NOTIFICATION_STATE_GLOBAL = '__appNotificationShow';

export const DEFAULT_USER_IMAGE = '/static/dashboard/img/default-user.svg';
export const SINGULAR_LOGO = '/static/dashboard/img/logos/singular_flat_logo_white.svg';
export const SINGULAR_LOGO_ICON = '/static/dashboard/img/logos/logo_only.svg';

export const SUPPORTED_LANGUAGES = [
    { code: 'en', displayName: 'English', icon: 'flag-icon flag-icon-us' },
    { code: 'ja', displayName: '日本語', icon: 'flag-icon flag-icon-jp' },
    { code: 'ko', displayName: '한국어', icon: 'flag-icon flag-icon-kr' },
    { code: 'cn', displayName: '中文', icon: 'flag-icon flag-icon-cn' },
];
